
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';

// Lazy loaded pages
const ListAllSprintPage = loadable(() => import('./ListAllSprintPage'), {
  fallback: <Loader />,
});
// const AddSprintPage = loadable(() => import('./AddSprintPage'), {
//   fallback: <Loader />,
// });
// const EditSprintPage = loadable(() => import('./EditSprintPage'), {
//   fallback: <Loader />,
// });
const ViewAllSprintPage = loadable(() => import('./ViewAllSprintPage'), {
  fallback: <Loader />,
});

const AllSprintRoute = ({ t }) => {
  return (
    <Routes>
      <Route index element={<ListAllSprintPage t={t} />} />
      <Route path="/list" element={<ListAllSprintPage t={t} />} />
      {/* <Route path="/add" element={<AddSprintPage t={t} />} /> */}
      {/* <Route path="/edit/:id" element={<EditSprintPage t={t} />} /> */}
      <Route path="/view/:id" element={<ViewAllSprintPage t={t} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

AllSprintRoute.propTypes = {
  t: PropTypes.func,
};

export default AllSprintRoute;
